import { render, staticRenderFns } from "./ProcessPostList.vue?vue&type=template&id=660cd0c2&scoped=true&"
import script from "./ProcessPostList.vue?vue&type=script&lang=js&"
export * from "./ProcessPostList.vue?vue&type=script&lang=js&"
import style0 from "./ProcessPostList.vue?vue&type=style&index=0&id=660cd0c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660cd0c2",
  null
  
)

export default component.exports